import React from 'react';
import './DetailedHistory.css';

function DetailedHistory() {
  return (
    <section className="detailed-history-section">
      <div className="container">
        <div className="detailed-history-content">
          <h2 className="detailed-history-title">La historia de Tabia Group</h2>
          
          <p className="history-paragraph">
            Tabia Group es un holding patrimonial y empresarial diversificado, con un enfoque principal —aunque no exclusivo— en el sector inmobiliario. La compañía nace en las Islas Baleares, un enclave históricamente ligado a la inversión y al patrimonio inmobiliario, y desde sus orígenes adopta una clara vocación nacional e internacional.
          </p>
          
          <p className="history-paragraph">
            Con una fuerte presencia en la península ibérica y una actividad inversora que trasciende fronteras, Tabia Group ha prestado asesoramiento en inversiones inmobiliarias en más de nueve países, acompañando a inversores privados, family offices y estructuras empresariales en la toma de decisiones estratégicas de alto impacto patrimonial.
          </p>
          
          <p className="history-paragraph">
            El grupo estructura su actividad a través de tres líneas de negocio complementarias, diseñadas para cubrir todo el ciclo de valor del activo inmobiliario:
          </p>
          
          <div className="services-list">
            <div className="service-item">
              <h3>Inversión inmobiliaria</h3>
              <p>
                Centrada en la identificación, estructuración y ejecución de oportunidades con alto potencial de rentabilidad y preservación de valor.
              </p>
            </div>
            
            <div className="service-item">
              <h3>Gestión patrimonial inmobiliaria</h3>
              <p>
                Desarrollada a través de TABIA Gestión, orientada a la optimización, control y crecimiento eficiente de carteras inmobiliarias.
              </p>
            </div>
            
            <div className="service-item">
              <h3>Intermediación inmobiliaria</h3>
              <p>
                Canalizada mediante TABIA Inmobiliaria, especializada en la identificación y estructuración de operaciones de compraventa de activos inmobiliarios, con un enfoque estratégico, discreto y altamente profesionalizado.
              </p>
            </div>
          </div>
          
          <p className="history-paragraph">
            Actualmente, Tabia Group gestiona un patrimonio inmobiliario valorado en más de 390 millones de euros, reflejo de su capacidad para diseñar soluciones integrales, sólidas y alineadas con los intereses de clientes e inversores, combinando visión estratégica, conocimiento profundo del mercado y una ejecución rigurosa.
          </p>
          
          <p className="history-paragraph">
            Al frente de la compañía se encuentra David Pons, presidente de Tabia Group, un joven empresario e inversor con una trayectoria forjada desde muy temprana edad en el sector inmobiliario. Su capacidad para identificar oportunidades, estructurar inversiones y anticipar ciclos de mercado ha sido clave en la consolidación del grupo como un socio de confianza para inversores nacionales e internacionales.
          </p>
          
          <p className="history-paragraph closing-paragraph">
            Hoy, Tabia Group representa una forma de entender la inversión inmobiliaria basada en la disciplina, la visión a largo plazo y la creación de valor sostenible, posicionándose como un actor relevante en el panorama inmobiliario español con una sólida proyección internacional.
          </p>
        </div>
      </div>
    </section>
  );
}

export default DetailedHistory;
